import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Text } from '@dls/web';
import { useEffect } from 'react';
const ErrorSlate = props => {
  const {
    error,
    errorMessages,
    setError,
    rightAlign
  } = props;
  useEffect(() => {
    if (setError && error && error.validationError) {
      Object.entries(error.validationError).forEach(_ref => {
        let [key, value] = _ref;
        setError(key, {
          message: Array.isArray(value) ? value.join(" ") : String(value)
        }, {
          shouldFocus: true
        });
      });
    }
  }, [error, setError]);
  const errorMsgs = errorMessages && errorMessages !== "" ? typeof errorMessages === "string" ? [errorMessages] : errorMessages : void 0;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [error && /* @__PURE__ */jsx(Text, {
      className: "text-danger" + (rightAlign ? " text-end" : ""),
      children: error.message
    }), errorMsgs && errorMsgs.map((msg, index) => /* @__PURE__ */jsx(Text, {
      className: "text-danger" + (rightAlign ? " text-end" : ""),
      children: msg
    }, index))]
  });
};
export { ErrorSlate as default };